import { Redirect, Route, Switch } from 'react-router-dom';
import SideMenu from '../../components/SideMenu/SideMenu'

import Container from './components/Container/Container'

import ColumnIntro from './components/Column/Intro'
import ColumnSizes from './components/Column/Sizes'
import ColumnGrid from './components/Column/ColumnGrid';
import ColumnBreakpoints from './components/Column/ColumnBreakpoints'
import Column from './components/Column/Column'
import ColumnBg from './components/Column/ColumnBg'

const DUMMY_LINKS = [
    { content: 'Container', url: '/grid/container' },
    { content: 'Col', url: '/grid/column' },
    { content: 'ColSizes', url: '/grid/column/sizes' },
    { content: 'ColGrid', url: '/grid/column/grid' },
    { content: 'ColBreakpoints', url: '/grid/column/breakpoints' },
    { content: 'ColColumn', url: '/grid/column/column' },
    { content: 'ColColumnBg', url: '/grid/column/column/bg' }
]


const Grid = () => {

    return <div className='container fluid pt-2 pb-6'>
        <div className='row'>
            <div className='col md-I order-last menu-column'>
                <SideMenu links={DUMMY_LINKS} />
            </div>
            <div className='col md-V content-column'>
                <Switch>
                    <Route path='/grid/container' exact render={() => <Container />} />
                    <Route path='/grid/column' exact render={() => <ColumnIntro />} />
                    <Route path='/grid/column/sizes' render={() => <ColumnSizes />} />
                    <Route path='/grid/column/grid' render={() => <ColumnGrid />} />
                    <Route path='/grid/column/breakpoints' render={() => <ColumnBreakpoints />} />
                    <Route path='/grid/column/column' exact render={() => <Column />} />
                    <Route path='/grid/column/column/bg' render={() => <ColumnBg />} />
                    <Redirect from='/grid' to='/grid/container' />
                </Switch>
            </div>
        </div>
    </div>
}

export default Grid